module.exports = __webpack_public_path__ + "static/media/comp-crushing-s.b71ef7f6.jpg";